import React from "react";
import { ChannelIcon, channelIconBg } from "./ChannelIcons";
import { CHANNELS } from "./data";
import { trackEvent } from "./trackEvent";

function ChannelCard({ icon, name, handle, href }) {
  return (
    <a
      className="card channel-card"
      href={href}
      target="_blank"
      rel="noopener"
      onClick={() => trackEvent("outbound_channel_click", { channel: icon, name })}
    >
      <span className="channel-icon" style={{ background: channelIconBg(icon) }}>
        <ChannelIcon icon={icon} />
      </span>
      <div>
        <div className="channel-name">{name}</div>
        <div className="channel-handle">{handle}</div>
      </div>
    </a>
  );
}

export default function ChannelsList({ title = "Nos acompanhe", compact = false }) {
  return (
    <div>
      <div className="section-head" style={{ marginTop: compact ? 0 : 26, marginBottom: 14 }}>
        <h2 style={{ fontSize: 16 }}>{title}</h2>
      </div>
      <div className="channels-groups">
        <div className="channels-group">
          <p className="channels-group-title">Da igreja</p>
          <div className="channels-group-list">
            {CHANNELS.igreja.map((c) => <ChannelCard key={c.href} {...c} />)}
          </div>
        </div>
        <div className="channels-group">
          <p className="channels-group-title">Do pastor</p>
          <div className="channels-group-list">
            {CHANNELS.pastor.map((c) => <ChannelCard key={c.href} {...c} />)}
          </div>
        </div>
      </div>
    </div>
  );
}
